import React, {useState} from 'react'
import styled from 'styled-components'

const Form = () => {

    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')



    

  return (
    <StyledForm>
      <Input onChange={e => setName(e.target.value)} type="text" name='name' placeholder="Name" />
      <Input onChange={e => setPhone(e.target.value)} type="email" name='email' placeholder="Email" />
      <Input onChange={e => setEmail(e.target.value)} type="tel" name='number' placeholder="Phone Number" />
      <TextArea onChange={e => setMessage(e.target.value)} name='message' placeholder="Message" />
      <Button>Send Message</Button>
    </StyledForm>
  )
}

export default Form

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;

  &:last-child{
    align-items: flex-end;
  }

  gap: 2.5rem;
`

const Input = styled.input`
  width: 100%;
  padding: 1.5rem;
  font-family: var(--font-secondary);
  font-size: 1.2rem;
  font-weight: 300;

  &::placeholder {
    color: #515151;
    font-family: var(--font-secondary);
    font-size: 1rem;
    font-weight: 400;
  }

  outline: none;
`

const TextArea = styled.textarea`
  width: 100%;
  padding: 1.5rem;
  resize: none;
  font-weight: 300;

  &::placeholder {
    color: #515151;
    font-family: var(--font-secondary);
    font-size: 1rem;
    font-weight: 400;
  }

  outline: none;

`

const Button = styled.button`
  color: #FFF;
  text-align: center;
  font-family: var(--font-secondary);
  font-size: 1.4rem;
  font-weight: 500;
  padding: 1.2rem;
  background: #F2B705;
  border: none;
  outline: none;

  width: 50%;
  
`

const Error = styled.div``